/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaInstagram, FaMapMarkedAlt } from 'react-icons/fa';
import SectionIcons from './SectionIcons';
import HomeHader from './HomeHader';
import HomeHorario from './HomeHorario';
import {
  TitileInsta,
  SubtitleInsta,
  BGInsta,
  TitleLink,
  TitleGoogle,
  SubtitleGoogle,
  H6,
} from './styles';
import SectionRedesSociais from './SectionRedesSociais';

const Home = () => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setTimeout(() => setLoading(true), 100);
  }, []);

  return (
    <>
      {/* Header */}
      <HomeHader />
      {/* Horario */}
      <HomeHorario />
      {/* Icones */}
      <SectionIcons />
      <BGInsta className="my-5">
        <Container fluid>
          <Row>
            <Col className="text-center">
              <TitileInsta>Compartailhe seu momento com a gente</TitileInsta>
              <SubtitleInsta>#AMOSABOREARRESTO</SubtitleInsta>
              <a
                href="https://www.instagram.com/saborearresto/"
                target="_blank"
                without="true"
                title="Instagram"
                rel="noopener noreferrer"
              >
                <FaInstagram size={50} />
                <TitleLink>@SABOREARRESTO</TitleLink>
              </a>
            </Col>
          </Row>
        </Container>
      </BGInsta>

      <Container className="mt-5">
        <Row>
          <Col className="text-center">
            <FaMapMarkedAlt size={80} />
            <TitleGoogle>Encontre o</TitleGoogle>
            <SubtitleGoogle>SABOREAR RESTAURANTE</SubtitleGoogle>
          </Col>
        </Row>
        <Row className="my-5">
          <Col xs={12}>
            {loading && (
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3974.8145674959474!2d-39.0177607!3d-4.9704672!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7be9fa95f6cc4e1%3A0xf211cee2578985a7!2sSaborear%20Restaurante!5e0!3m2!1spt-BR!2sbr!4v1579544083122!5m2!1spt-BR!2sbr"
                width="100%"
                height="450"
                style={{ border: 0, frameBorder: 0 }}
                allowFullScreen=""
              />
            )}
          </Col>
          <Col xs={12} className="text-center">
            <H6>Rua Pascoal Crispino nº 285, Centro Quixadá - CE</H6>
          </Col>
        </Row>
      </Container>
      <SectionRedesSociais />
    </>
  );
};

Home.propTypes = {};

export default Home;
